import request from '@/common/request'
import { AxiosRequestConfig } from 'axios'
import { BagsECrediarioDoCliente, MixETopPecasDoCliente, PerfilDoCliente } from '@/models/PainelDoCliente'

const PATH = '/clientes'

export const buscarPerfil = async (clienteId: string, lojaId: string, config?: AxiosRequestConfig): Promise<PerfilDoCliente> =>
	request.get(`${PATH}/${clienteId}/painel/perfil`, {
		params: { lojaId },
		...config,
	})

export const buscarMixETopPecas = async (clienteId: string, lojaId: string, config?: AxiosRequestConfig): Promise<MixETopPecasDoCliente> =>
	request.get(`${PATH}/${clienteId}/painel/mix-e-top-pecas`, {
		params: { lojaId },
		...config,
	})

export const buscarBagsECrediario = async (clienteId: string, lojaId: string, config?: AxiosRequestConfig): Promise<BagsECrediarioDoCliente> =>
	request.get(`${PATH}/${clienteId}/painel/bags-e-crediario`, {
		params: { lojaId },
		...config,
	})
